import React, { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Components
import Max2SearchFilter from '../search/filter';
import Max2SearchResult from '../search/result';
import AjaxController from '../system/ajaxController';

// Redux slices
import { setActivePage, setUser, setToken } from '../../appSlice';
import { setWatchlist, setLastObjects } from './dashboardSlice';
import { setObjectId, setContractId } from '../../appSlice';

// SemanticUI components
import { Grid, GridRow, GridColumn, Button, Icon } from 'semantic-ui-react';
import { Segment, Label, ListItem, ListIcon, ListHeader, ListDescription, ListContent, List } from 'semantic-ui-react'

// Styles
import './dashboard.css';


registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @returns 
 */
const Max2LastObjects = () => {
  // local state
  const [limit, setLimit] = React.useState(5);

  // global state
  const dispatch = useDispatch();
  const lastObjects = useSelector((state) => state.dashboard.lastObjects);
  const backendUrl = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);
  const user = useSelector((state) => state.app.user);
  const { t } = useTranslation();

  // Snackbar
  //const { enqueueSnackbar } = useSnackbar();
  
  const fetchLastObjects = useCallback(() => {
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });
    api.get('/history/user/' + user.uid).then(response => {
      if (response.length) {
        let itemsOpen = [];
        response.forEach(item => {
          if (item.operation_details.action === 'OPEN') {
            itemsOpen.push(item);
          }
        });
        dispatch(setLastObjects(itemsOpen));
      }
    });
  }, [backendUrl, dispatch, user.uid]);

  useEffect(() => {
    if (typeof lastObjects === 'undefined' || lastObjects === null || lastObjects.length === 0) {
      fetchLastObjects();
    }
  }, [lastObjects, fetchLastObjects]);



  /**
   * @param {string} target
   * @param {integer} oid 
   */
  const handleOpenObjectClick = (target, oid) => {
    switch (target) {
      case 'OBJECT': 
        dispatch(setActivePage('OBJECT'));
        dispatch(setObjectId(oid));
        break;

      case 'CONTRACT': 
        dispatch(setActivePage('CONTRACT'));
        //dispatch(setObjectId(oid));
        dispatch(setContractId(oid));
        break;
      default: break;
    }
  }



  // check if watchlist is empty
  if (typeof lastObjects === 'undefined' || lastObjects === null || lastObjects.length === 0) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{t('dashboard.history.title')}</span></Label>
        <List divided relaxed>
          <ListItem>
            <ListContent>
              <ListHeader as='a'>{t('common.noEntries')}</ListHeader>
            </ListContent>
          </ListItem>
        </List>
      </Segment>
    )
  }

  return (
    <Segment textAlign='left' style={{margin: '25px'}}>
      <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{t('dashboard.history.title')}</span></Label>
      <List divided relaxed>
        {lastObjects.map((item, index) => {
          if (index >= limit) return <></>;
          const created_at = format(new Date(item.created_at), 'dd.MM.yyyy HH:mm:ss');
          let icon = <></>;
          switch (item.operation_details.action) {
            case 'LOGIN': icon = <ListIcon name='sign in' />; break;
            case 'LOGOUT': icon = <ListIcon name='log out' />; break;
            case 'OPEN': icon = <ListIcon name='folder open' />; break;
            case 'INSERT': icon = <ListIcon name='file outline' />; break;
            case 'UPDATE': icon = <ListIcon name='save' />; break;
            case 'DELETE': icon = <ListIcon name='trash' />; break;
            default: icon = <ListIcon name='history' />; break;
          }
          return (
            <ListItem key={index}>
              {icon}
              <ListContent>
                <ListHeader as='a' onClick={() => handleOpenObjectClick(item.target, item.target_id)}>{item.operation_text}</ListHeader>
                <ListDescription>{created_at}, {item.user_name} {item.target}</ListDescription>
              </ListContent>
            </ListItem>
          )
        })}
      </List>
      {lastObjects.length > limit && (<Button basic circular onClick={()=>setLimit(limit + 5)}>mehr ...</Button>)}
    </Segment>
  )
}



/**
 * 
 * @returns 
 *
const Max2Notifications = () => {
  const { t } = useTranslation();
  return (
    <Segment textAlign='left' style={{margin: '25px', opacity: '0.5'}}>
      <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{t('dashboard.notifications.title')} (2)</span></Label>
      <List divided relaxed>
        <ListItem>
          <ListIcon name='envelope outline' size='large' verticalAlign='middle' />
          <ListContent>
            <ListHeader as='a'>Mitteilung</ListHeader>
            <ListDescription as='a'>Lorem Ipsum dolor set amet consec...</ListDescription>
          </ListContent>
        </ListItem>
        <ListItem>
          <ListIcon name='envelope outline' size='large' verticalAlign='middle' />
          <ListContent>
            <ListHeader as='a'>Stopsale gesetzt</ListHeader>
            <ListDescription as='a'>PMI123B, EB, 10.10.2024 - 12.10.2024</ListDescription>
          </ListContent>
        </ListItem>
        <ListItem>
          <ListIcon name='envelope open outline' size='large' verticalAlign='middle' />
          <ListContent>
            <ListHeader as='a'>TUK_1ABC2</ListHeader>
            <ListDescription as='a'>Vertriebskanal HLX aktiviert</ListDescription>
          </ListContent>
        </ListItem>
      </List>
      <Button basic circular>mehr ...</Button>
    </Segment>
  )
}
/**/


/**
 * 
 * @returns 
 */
const Max2Watchlist = () => {
  const { t } = useTranslation();

  // local state
  const [limit, setLimit] = React.useState(5);

  // global state
  const dispatch = useDispatch();
  const watchlist = useSelector((state) => state.dashboard.watchlist);
  const backendUrl = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);
  const user = useSelector((state) => state.app.user);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();
  
  const fetchWatchlist = useCallback(() => {
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });
    api.get('/watchlist/' + user.uid).then(response => {
      if (response.length) {
        dispatch(setWatchlist(response));
      }
    });
  }, [backendUrl, dispatch, user.uid]);

  useEffect(() => {
    if (typeof watchlist === 'undefined' || watchlist === null || watchlist.length === 0) {
      fetchWatchlist();
    }
  }, [watchlist, fetchWatchlist]);


  /**
   * @param {string} target
   * @param {integer} oid 
   */
  const handleOpenObjectClick = (target, oid) => {
    switch (target) {
      case 'OBJECT': 
        dispatch(setActivePage('OBJECT'));
        dispatch(setObjectId(oid));
        break;
      default: break;
    }
  }



  /**
   *
   * @param {integer} id
   */
  const handleCheckItem = (id) => {
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });
    api.delete('/watchlist/' + id).then(response => {
      if (response.status === 'success') {
          dispatch(setWatchlist(response.records));
      } else {
          console.error('Error:', response);
          enqueueSnackbar('Fehler beim Abhaken des Eintrags', { variant: 'error' });
      }
    });
  }


  // check if watchlist is empty
  if (typeof watchlist === 'undefined' || watchlist === null || watchlist.length === 0) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{t('dashboard.watchlist.title')}</span></Label>
        <List divided relaxed>
          <ListItem>
            <ListContent>
              <ListHeader as='a'>{t('common.noEntries')}</ListHeader>
            </ListContent>
          </ListItem>
        </List>
      </Segment>
    )
  }

  return (
    <Segment textAlign='left' style={{margin: '25px'}}>
      <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{t('dashboard.watchlist.title')} ({watchlist.length})</span></Label>
      <List divided relaxed>
        {watchlist.map((item, index) => {
          if (index >= limit) return <></>;
          return (
            <ListItem key={index}>
              <ListContent floated='right'>
                <Button basic circular icon size='tiny' title="Eintrag als erledigt markieren" onClick={()=>handleCheckItem(item.id)}><Icon name='check' /></Button>
              </ListContent>
              <ListContent>
                <ListHeader as='a' onClick={() => handleOpenObjectClick(item.item_type, item.item_id)}>{item.item_type === 'OBJECT' ? 'Hotel' : 'Vertrag'} &laquo;{item.item_name}&raquo;</ListHeader>
                <ListDescription>{item.note}</ListDescription>
              </ListContent>
            </ListItem>
          )
        })}
      </List>
      {watchlist.length > limit && (<Button basic circular onClick={()=>setLimit(limit + 5)}>mehr ...</Button>)}
    </Segment>
  )
}



/**
 * 
 * @returns 
 */
const Max2Dashboard = () => {
  
  return (
    <Grid>
      <GridRow columns={2}>
        <GridColumn width={12}>
          <Max2SearchFilter />
          <Max2SearchResult />
        </GridColumn>
        <GridColumn width={4}>
          <Max2Watchlist />
          <Max2LastObjects />
          {/*<Max2Notifications />*/}
        </GridColumn>
      </GridRow>
    </Grid>
  );
}

export default Max2Dashboard;
